import React from 'react';
import { Col, Container, Row, Button } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import ChemComponent from '../ChemComponent';
import { withRouter } from '../withRouter';
import ChemEdit from '../ChemEdit';

class Donate extends ChemComponent {
	constructor(props) {
		super(props);
			
		this.state = {
			donation: {
				FROM: '',
				TO: '',
				SUBJECT: '',
				MESSAGE: ''
			},
			renderKey: 0
		};
	}	

	componentDidMount() {
		var self = this;
		
		this.ajax({
			type: 'POST',
			url: this.getConfig().host + '/Reuse/GetDonationMessage',
			overlay: true,
			data: { __RequestVerificationToken: this.props.user.antiForgeryToken }
		}).done(function (data) {
			if (data.Success) {
				self.mergeState({ 
					donation: {
						FROM: data.Data.EMAIL,
						TO: 'cchemreuse@berkeley.edu',
						SUBJECT: 'Chemical donation',
						MESSAGE: ''
					}
				});
			} else {
				self.showAlert('Server Error', data.Message);
			}
		}).fail(function (jqXHR, textStatus, errorThrown) {
			self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
		});
	}

	onChange(accessor, value) {
		var donation = this.copyObject(this.state.donation);
		this.setByAccessor(donation, accessor, value);
		this.mergeState({ donation: donation });
	}
	
	validateDonation() {
		return this.validate(donationColumns, this.state.donation);
	}
	
	onSubmit(event) {
		var self = this;
		
		this.ajax({
			type: 'POST',
			url: this.getConfig().host + '/Reuse/SendDonationMessage',
			overlay: true,
			data: { __RequestVerificationToken: this.props.user.antiForgeryToken, donation: this.state.donation }
		}).done(function (data) {
			if (data.Success) {
				self.props.parent.showConfirmation(() => {
					return (<>
						Your message has been sent.
					</>);
				});
			} else {
				self.showAlert('Server Error', data.Message);
			}
		}).fail(function (jqXHR, textStatus, errorThrown) {
			self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
		});
	}
	
	render() {		
		return (<>
			<Container fluid>
			  <Row>
			    <Col style={{ paddingTop: '20px', paddingBottom: '10px', border: '1px solid #ccc', backgroundColor: '#FEFEFE' }}>
				  <Container fluid>
					<Row>
					  <Col>
						  <div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' }}>Contact us about chemical donations</div>
					  </Col>
					</Row>
					<Row>
					  <Col style={{ borderBottom: '1px solid #eee' }}>
						<ChemEdit parent={this} user={this.props.user} columns={donationColumns} data={this.state.donation}
							validate={() => this.validateDonation()} onChange={(accessor, value) => this.onChange(accessor, value)}
							onSubmit={(event) => this.onSubmit(event)} renderKey={this.state.renderKey}>
						  <Form.Group>
							<Button id="save" variant="warning" type="submit" className="float-end">Send</Button>
						  </Form.Group>
						</ChemEdit>
					  </Col>
					</Row>
				  </Container>
				</Col>
			  </Row>
			</Container>
		</>);
	}
}

const donationColumns = [
	{ Header: 'From', accessor: 'FROM', row: 0, col: 0, editable: false },
	{ Header: 'To', accessor: 'TO', row: 0, col: 1, editable: false },
	{ Header: 'Subject', accessor: 'SUBJECT', row: 1, col: 0, colwidth: 12, labelColWidth: 3, valueColWidth: 9, editable: false },
	{ Header: 'Message', accessor: 'MESSAGE', type: 'textarea', row: 2, col: 0, colwidth: 12, labelColWidth: 3, valueColWidth: 9 }
];

export default withRouter(Donate);
